import { TaskGridCellType } from "@evennt-tech/api-v2-core";
import type { IGridSchema } from "ts/api/grid-schema";

/**
 * Editor cell-type tokens, backed by the core `TaskGridCellType` enum so
 * comparisons against the wire cell `type` (which is `TaskGridCellType`)
 * typecheck without redeclaring the union.
 */
export const CellType = {
  Options: TaskGridCellType.OPTIONS,
  Text: TaskGridCellType.TEXT,
  Files: TaskGridCellType.FILES,
} as const;

/**
 * Minimal form shape consumed by the grid-editor sub-tree
 * (CustomizeTable / CTAs / Columns). Host forms always carry a
 * gridSchema slot; this is the only field the editor reads/writes.
 */
export type GridFormShape = {
  gridSchema?: IGridSchema;
};
